export const APARTMENT_VALIDATION = {
  default: {
    min: 0,
    max: 25
  },
  cl: {
    min: 0,
    max: 25
  }
};

export const MAX_PLACES_ADDRESS_NOTE = {
  default: {
    max: 45
  },
  cl: {
    max: 45
  }
};

export const MAX_CVC_LENGTH = 3;
